<div class="grid-x" [ngStyle]="{ 'display': isVisible ? 'inherit': 'none' }" [formGroup]="formGroup">
  <div class="cell">
    <form-control-label [id]="controlId" [question]="componentData"></form-control-label>
  </div>
  @if (showButton) {
    <div class="cell">
      <button class="button"  (click)="runQuery()" [disabled]="disableQuery" >
        {{ componentData.config.text }}
      </button>
    </div>
  }
  @if (queryRun$ | async) {
    <div class="cell small-12 minor-margin-top">
      @switch (componentData.config.display) {
        @case ('text') {
          <div class="bold result-text">
            {{ displayResults }}
          </div>
        }
        @case ('table') {
          <div>
            <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="tableData" aria-label="Data Query Button"></ag-grid-angular>
          </div>
        }
        @case ('selectable') {
          <div>
            <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="tableData" [rowSelection]="rowSelection" (selectionChanged)="onSelectionChanged($event)" aria-label="Data Query Button"></ag-grid-angular>
          </div>
        }
      }
      {{ errorMessage }}
    </div>
  }
  @if (queryResultsChanged) {
    <div class="builder-warning">
      Entity attributes returned by the query have changed since button was last configured!
    </div>
  }
</div>